export default __webpack_public_path__ + "static/sample-5d1907e61bc3d779052812b5f85af9ad.webp";